export default __webpack_public_path__ + "static/media/405.0ed3b7bc.gif";